export const subscriptionTypes = {
SUBSCRIBED: "SUBSCRIBED",
UNSUBSCRIBED: "UNSUBSCRIBED",
BLOCKED: "BLOCKED",
EXPIRED: "EXPIRED"
}